<style scoped></style>

<template>
  <v-btn
      :x-small="$store.state.mode !== 'static'"
      color="pink"
      outlined
      href="https://buy.stripe.com/4gw8z167zamo3Pq3cc"
      target="_blank"
      style="text-decoration: none; font-family: Inter; text-transform: none;  font-family: Inter; font-size: 12px;
                letter-spacing: normal; font-weight: normal;"
  >
    <v-icon style="font-size: 16px; margin-right: 5px;">mdi-thumb-up-outline</v-icon>
    <span class="d-none d-md-inline">
      {{ translate('ui_btn_support') }}
    </span>
  </v-btn>
</template>

<script>
import Mixin from '@/mixins/mixin';

export default {
  name: 'SupportBtn',
  mixins: [Mixin],
};
</script>
